export default "__VITE_ASSET__CPfxvzxI__"